/*** IMPORTS FROM imports-loader ***/
(function() {

"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var then_ajax_1 = require("then-ajax");
var axios_1 = require("axios");
var util_1 = require("~/js/lib/util/util");
var stat_1 = require("~@/widget/stat/stat");
var udb_1 = require("~@/widget/udb/udb");
var DEFAULT_AVATAR = require('~/images/default_portrait.jpg');
var TIMEOUT_LIMIT = 5000;
var INTERFACE = {
    USER_INFO: '//www.yy.com/yyweb/user/queryUserInfo.json',
    USER_INFO_BY_REVENUE: '//www.yy.com/ent/user/headerUserInfo.action?sid={$sid}',
    USERS_INFO: '//www.yy.com/yyweb/user/queryUserInfos.json?uidarray=[{$uids}]',
    MY_FOLLOW: '//www.yy.com/yyweb/user/queryLivePreview.json?_={$time}',
    ATTENTION_LIST: '//www.yy.com/yyweb/user/queryAttentionList.json?_={$time}',
    ATTENTION: '//www.yy.com/yyweb/user/attention.json?objectId={$uid}',
    LOGOUT: '//www.yy.com/login/logout',
    MY_MIDIA: '//yue.yy.com/tqw/userSubscribe/getSubscribedPublishes?_={$time}',
    SUBSCRIPTION_LIST: '//www.yy.com/yyweb/user/querySubscribeList?_={$time}',
    SUBSCRIPTION: '//www.yy.com/yyweb/user/subscribe?predictId={$eventId}',
    SPONSOR_INFO: '//www.yy.com/live/detail?uid={$uid}&sid={$sid}&ssid={$ssid}&_={$time}',
    SPONSOR_INFO_XIANCHANG: '//www.yy.com/live/detailCurrent?uid={$uid}&pid={$pid}&_={$time}',
    QRCODE: '//www.yy.com/download/qrcode?qrcode={$url}',
    CHERISH_LIST: '//www.yy.com/show/cherish/getCherishOpenStatus.action?anchorUid={$anchorUid}',
    LIVE_INFO: '//www.yy.com/api/liveInfoDetail/{$sid}/{$ssid}/{$uid}',
    USER_TYPE: '//www.yy.com/zone/userinfo/getUserType.json'
};
var cacheUserInfo = {};
var cacheSubscription = {};
var cacheAttendtion = {};
var cacheOnSubscriptionFns = [];
var cacheOnAttendtionFns = [];
function ajaxGet(url, options) {
    return __awaiter(this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, axios_1["default"].get(url, Object.assign({ withCredentials: true }, options))];
                case 1:
                    res = _a.sent();
                    return [2, res.data];
            }
        });
    });
}
function parseErr(er) {
    if (er.message === 'timeout') {
        return {
            code: 'ajax_timeout',
            errMsg: "request over " + TIMEOUT_LIMIT + " ms"
        };
    }
    else {
        return {
            code: 'ajax_error',
            errMsg: er.message
        };
    }
}
function fetchUserInfo(uid) {
    return __awaiter(this, void 0, void 0, function () {
        var rs, er, r, iUid, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (uid) {
                        return [2, fetchMultiUserInfo(uid)];
                    }
                    iUid = getUidSync();
                    if (!(iUid && cacheUserInfo[iUid])) return [3, 1];
                    r = cacheUserInfo[iUid];
                    return [3, 5];
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, then_ajax_1.thenJsonp(INTERFACE.USER_INFO, undefined, { timeout: TIMEOUT_LIMIT })];
                case 2:
                    rs = _a.sent();
                    return [3, 4];
                case 3:
                    err_1 = _a.sent();
                    er = parseErr(err_1);
                    rs = {
                        resultCode: er.code,
                        data: undefined,
                        errMsg: er.errMsg
                    };
                    return [3, 4];
                case 4:
                    if (rs.resultCode === 0) {
                        cacheUserInfo[rs.data.uid] = rs.data;
                        r = rs.data;
                    }
                    else {
                        er = {
                            code: rs.resultCode,
                            errMsg: rs.errMsg
                        };
                    }
                    _a.label = 5;
                case 5: return [2, [er, r]];
            }
        });
    });
}
exports.fetchUserInfo = fetchUserInfo;
function fetchMultiUserInfo(uid) {
    return __awaiter(this, void 0, void 0, function () {
        var uids, queryUids, ONCE_LIMIT, uidGroups, er, r;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    uids = [];
                    if (typeof uid === 'number') {
                        uids.push(uid);
                    }
                    else {
                        uids = uid;
                    }
                    queryUids = [];
                    uids.forEach(function (uid) {
                        if (!cacheUserInfo[uid]) {
                            queryUids.push(uid);
                        }
                    });
                    ONCE_LIMIT = 20;
                    uidGroups = [];
                    while (queryUids.length > ONCE_LIMIT) {
                        uidGroups.push(queryUids.splice(0, ONCE_LIMIT));
                    }
                    uidGroups.push(queryUids);
                    r = [];
                    return [4, util_1.forEach(uidGroups, function (iUids) { return __awaiter(_this, void 0, void 0, function () {
                            var rs, err_2;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4, then_ajax_1.thenJsonp(INTERFACE.USERS_INFO.replace('{$uids}', encodeURIComponent(iUids.join(','))), {}, { timeout: TIMEOUT_LIMIT })];
                                    case 1:
                                        rs = _a.sent();
                                        if (rs.resultCode === 0 && rs.data) {
                                            iUids.forEach(function (uid) {
                                                var fData;
                                                if (rs.data[uid]) {
                                                    fData = rs.data[uid];
                                                    fData.logo = fData.logo || fData.hdLogo || DEFAULT_AVATAR;
                                                    fData.nick = fData.nick || "YY_" + fData.uid;
                                                }
                                                else {
                                                    fData = {
                                                        uid: uid,
                                                        nick: "YY_" + uid,
                                                        logo: DEFAULT_AVATAR,
                                                        isGuest: true
                                                    };
                                                }
                                                cacheUserInfo[fData.uid] = fData;
                                            });
                                        }
                                        return [3, 3];
                                    case 2:
                                        err_2 = _a.sent();
                                        er = parseErr(err_2);
                                        return [2, true];
                                    case 3: return [2];
                                }
                            });
                        }); })];
                case 1:
                    _a.sent();
                    uids.forEach(function (uid) {
                        r.push(cacheUserInfo[uid] || {
                            uid: uid,
                            nick: "YY_" + uid,
                            logo: DEFAULT_AVATAR,
                            isGuest: true
                        });
                    });
                    return [2, [er, r]];
            }
        });
    });
}
exports.fetchMultiUserInfo = fetchMultiUserInfo;
function getUserInfo() {
    var argu = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        argu[_i] = arguments[_i];
    }
    var cb;
    var uid;
    if (argu.length === 1) {
        cb = argu[0];
    }
    else if (argu.length === 2) {
        uid = argu[0];
        cb = argu[1];
    }
    fetchUserInfo(uid).then(function (arr) {
        if (arr[0]) {
            cb(false);
        }
        else {
            cb(arr[1]);
        }
    })["catch"](function (er) {
        cb(false);
    });
}
exports.getUserInfo = getUserInfo;
function fetchUserInfoByRevenue() {
    return __awaiter(this, void 0, void 0, function () {
        var sid, rs, er, r, nobleLevelNames, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    sid = (window.pageInfo && window.pageInfo.sid) ? window.pageInfo.sid : '';
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, ajaxGet(INTERFACE.USER_INFO_BY_REVENUE.replace('{$sid}', sid), { timeout: TIMEOUT_LIMIT })];
                case 2:
                    rs = _a.sent();
                    if (rs.result === 0) {
                        nobleLevelNames = ['平民', '国王', '公爵', '侯爵', '伯爵', '子爵', '男爵', '勋爵'];
                        r = {
                            isExpired: rs.nobleGrowInfo.isExpired,
                            nobleLevel: rs.nobleGrowInfo.nobleLevel || 0,
                            honourLevel: rs.nobleGrowInfo.honourLevel || 0,
                            curHonour: rs.nobleGrowInfo.curHonour || 0,
                            goalHonour: rs.nobleGrowInfo.goalHonour || 0,
                            honourRatio: (rs.nobleGrowInfo.curHonour && rs.nobleGrowInfo.goalHonour) ?
                                (rs.nobleGrowInfo.curHonour / rs.nobleGrowInfo.goalHonour) * 100 :
                                0,
                            diamond: util_1.moneyFormat(rs.assetsInfo.diamond + rs.assetsInfo.actDiamond),
                            yyMoney: util_1.moneyFormat(rs.assetsInfo.yyMoney),
                            yyMoneyOriginal: rs.assetsInfo.yyMoney,
                            hadCherish: rs.cherishInfo.hadCherish,
                            cherishGroupName: rs.cherishInfo.hadCherish ? rs.cherishInfo.cherishGroup.groupname : '',
                            isAnchor: rs.role === 1 || rs.role === 2,
                            role: rs.role,
                            nobleLevelName: nobleLevelNames[parseInt(rs.nobleGrowInfo.nobleLevel, 10)]
                        };
                    }
                    else {
                        er = {
                            code: rs.result,
                            errMsg: rs.errMsg
                        };
                    }
                    return [3, 4];
                case 3:
                    err_3 = _a.sent();
                    er = parseErr(err_3);
                    return [3, 4];
                case 4: return [2, [er, r]];
            }
        });
    });
}
exports.fetchUserInfoByRevenue = fetchUserInfoByRevenue;
function getUserInfoByRevenue(done) {
    fetchUserInfoByRevenue().then(function (arr) {
        if (arr[0]) {
            done(false);
        }
        else {
            done(arr[1]);
        }
    })["catch"](function (er) {
        done(false);
    });
}
exports.getUserInfoByRevenue = getUserInfoByRevenue;
function fetchLiveInfo(op) {
    return __awaiter(this, void 0, void 0, function () {
        var url, er, r, rs, err_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = INTERFACE.LIVE_INFO
                        .replace('{$sid}', "" + op.sid)
                        .replace('{$ssid}', "" + (op.ssid || 0))
                        .replace('{$uid}', "" + (op.uid || 0));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, ajaxGet(url, { timeout: TIMEOUT_LIMIT })];
                case 2:
                    rs = _a.sent();
                    if (rs.resultCode === 0) {
                        r = rs.data;
                    }
                    else {
                        er = {
                            code: rs.resultCode,
                            errMsg: rs.errMsg
                        };
                    }
                    return [3, 4];
                case 3:
                    err_4 = _a.sent();
                    er = parseErr(err_4);
                    return [3, 4];
                case 4: return [2, [er, r]];
            }
        });
    });
}
exports.fetchLiveInfo = fetchLiveInfo;
function getLiveInfo(op, done) {
    fetchLiveInfo(op).then(function (arr) {
        if (arr[0]) {
            done(false);
        }
        else {
            done(arr[1]);
        }
    })["catch"](function (er) {
        done(false);
    });
}
exports.getLiveInfo = getLiveInfo;
function isLoginSync() {
    var r = util_1.cookies.get('udb_n') && util_1.cookies.get('udb_l') && util_1.cookies.get('yyuid');
    return r || false;
}
exports.isLoginSync = isLoginSync;
function getUidSync() {
    return util_1.cookies.get('yyuid') || 0;
}
exports.getUidSync = getUidSync;
function getNickSync() {
    var uid = getUidSync();
    if (uid && cacheUserInfo[uid]) {
        return cacheUserInfo[uid].nick;
    }
    return '';
}
exports.getNickSync = getNickSync;
function getUserInfoSync() {
    var uid = getUidSync();
    if (uid && cacheUserInfo[uid]) {
        return cacheUserInfo[uid];
    }
    return;
}
exports.getUserInfoSync = getUserInfoSync;
function fetchMyFollow() {
    return __awaiter(this, void 0, void 0, function () {
        var url, rs, r, er, err_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = INTERFACE.MY_FOLLOW.replace('{$time}', "" + +new Date());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, ajaxGet(url, { timeout: TIMEOUT_LIMIT })];
                case 2:
                    rs = _a.sent();
                    if (rs.data) {
                        r = rs.data;
                    }
                    else {
                        r = {
                            att: [],
                            sub: []
                        };
                    }
                    return [3, 4];
                case 3:
                    err_5 = _a.sent();
                    er = parseErr(err_5);
                    return [3, 4];
                case 4: return [2, [er, r]];
            }
        });
    });
}
exports.fetchMyFollow = fetchMyFollow;
function getMyFocus(done) {
    fetchMyFollow().then(function (arr) {
        if (arr[0]) {
            done(false);
        }
        else {
            done(arr[1]);
        }
    })["catch"](function () {
        done(false);
    });
}
exports.getMyFocus = getMyFocus;
function logout(done) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, udb_1.udb.logout(getUidSync())];
                case 1:
                    _a.sent();
                    return [2, done && done()];
            }
        });
    });
}
exports.logout = logout;
function showYYLoginBox(done) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, udb_1.udb.login()];
                case 1:
                    _a.sent();
                    if (done) {
                        done();
                    }
                    return [2];
            }
        });
    });
}
exports.showYYLoginBox = showYYLoginBox;
function hideYYLoginBox(done) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, udb_1.udb.hide()];
                case 1:
                    _a.sent();
                    if (done) {
                        done();
                    }
                    return [2];
            }
        });
    });
}
exports.hideYYLoginBox = hideYYLoginBox;
function showYYRegBox() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, udb_1.udb.register()];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    });
}
exports.showYYRegBox = showYYRegBox;
function hideYYRegBox(done) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, udb_1.udb.hide()];
                case 1:
                    _a.sent();
                    if (done) {
                        done();
                    }
                    return [2];
            }
        });
    });
}
exports.hideYYRegBox = hideYYRegBox;
function getMacAddr(done) {
    if (window.getMC) {
        window.getMC(function (mac) {
            done(mac);
        });
    }
    else {
        done('');
    }
}
exports.getMacAddr = getMacAddr;
function getUdbMC(done) {
    return getMacAddr(done);
}
exports.getUdbMC = getUdbMC;
function getQrcodeSync(url) {
    return INTERFACE.QRCODE.replace('{$url}', encodeURIComponent(url));
}
exports.getQrcodeSync = getQrcodeSync;
function fetchAttentionList() {
    return __awaiter(this, void 0, void 0, function () {
        var rs, r, er, url, err_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = INTERFACE.ATTENTION_LIST.replace('{$time}', "" + +new Date());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, ajaxGet(url, { timeout: TIMEOUT_LIMIT })];
                case 2:
                    rs = _a.sent();
                    if (rs.resultCode === 0) {
                        r = rs.data;
                        cacheAttendtion[getUidSync()] = rs.data;
                    }
                    else {
                        er = {
                            code: rs.resultCode,
                            errMsg: rs.errMsg
                        };
                    }
                    return [3, 4];
                case 3:
                    err_6 = _a.sent();
                    er = parseErr(err_6);
                    return [3, 4];
                case 4: return [2, [er, r]];
            }
        });
    });
}
exports.fetchAttentionList = fetchAttentionList;
function queryAttentionList(done) {
    if (!getUidSync()) {
        done([]);
    }
    else {
        fetchAttentionList().then(function (arr) {
            if (arr[0]) {
                done([]);
            }
            else {
                done(arr[1]);
            }
        })["catch"](function (er) {
            done([]);
        });
    }
}
exports.queryAttentionList = queryAttentionList;
function fetchSubscriptionList() {
    return __awaiter(this, void 0, void 0, function () {
        var rs, r, er, url, err_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    url = INTERFACE.SUBSCRIPTION_LIST.replace('{$time}', "" + +new Date());
                    return [4, ajaxGet(url, { timeout: TIMEOUT_LIMIT })];
                case 1:
                    rs = _a.sent();
                    if (rs.resultCode === 0) {
                        r = rs.data;
                        cacheSubscription[getUidSync()] = rs.data;
                    }
                    else {
                        er = {
                            code: rs.resultCode,
                            errMsg: rs.errMsg
                        };
                    }
                    return [3, 3];
                case 2:
                    err_7 = _a.sent();
                    er = parseErr(err_7);
                    return [3, 3];
                case 3: return [2, [er, r]];
            }
        });
    });
}
exports.fetchSubscriptionList = fetchSubscriptionList;
function querySubscriptionList(done) {
    if (!isLoginSync()) {
        done([]);
    }
    else {
        fetchSubscriptionList().then(function (arr) {
            if (arr[0]) {
                done([]);
            }
            else {
                done(arr[1]);
            }
        })["catch"](function (er) {
            done([]);
        });
    }
}
exports.querySubscriptionList = querySubscriptionList;
function isAttentionSync(uid, uids) {
    return uids.indexOf(+uid) !== -1;
}
exports.isAttentionSync = isAttentionSync;
function isSubscriptionSync(eventid, eventids) {
    return eventids.indexOf(eventid) !== -1;
}
exports.isSubscriptionSync = isSubscriptionSync;
function subscription(eventid, callback) {
    return __awaiter(this, void 0, void 0, function () {
        var r, er, rs, err_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!isLoginSync()) return [3, 2];
                    return [4, showYYLoginBox()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4, ajaxGet(INTERFACE.SUBSCRIPTION.replace('{$eventId}', "" + eventid), { timeout: TIMEOUT_LIMIT })];
                case 3:
                    rs = _a.sent();
                    if (rs.resultCode === 0) {
                        r = true;
                    }
                    else {
                        er = {
                            code: rs.resultCode,
                            errMsg: rs.errMsg
                        };
                    }
                    return [3, 5];
                case 4:
                    err_8 = _a.sent();
                    er = parseErr(err_8);
                    return [3, 5];
                case 5: return [4, onSubscription()];
                case 6:
                    _a.sent();
                    if (r) {
                        callback(r);
                    }
                    else {
                        callback(false, er.errMsg);
                    }
                    return [2, [er, r]];
            }
        });
    });
}
exports.subscription = subscription;
function onSubscription(fn) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, er, ids_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!fn) return [3, 1];
                    cacheOnSubscriptionFns.push(fn);
                    return [3, 3];
                case 1:
                    if (!cacheOnSubscriptionFns.length) return [3, 3];
                    return [4, fetchSubscriptionList()];
                case 2:
                    _a = _b.sent(), er = _a[0], ids_1 = _a[1];
                    if (!er) {
                        cacheOnSubscriptionFns.forEach(function (fn) {
                            fn(ids_1);
                        });
                    }
                    _b.label = 3;
                case 3: return [2];
            }
        });
    });
}
exports.onSubscription = onSubscription;
function attention(uid, callback) {
    return __awaiter(this, void 0, void 0, function () {
        var r, er, rs, timeStart, iCacheUids, err_9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!isLoginSync()) return [3, 2];
                    return [4, showYYLoginBox()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    timeStart = +new Date();
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 5, , 6]);
                    return [4, ajaxGet(INTERFACE.ATTENTION.replace('{$uid}', "" + uid), { timeout: TIMEOUT_LIMIT })];
                case 4:
                    rs = _a.sent();
                    if (rs.resultCode === 0) {
                        r = true;
                        iCacheUids = cacheAttendtion[getUidSync()];
                        if (iCacheUids && iCacheUids.indexOf(+uid) === -1) {
                            iCacheUids.push(+uid);
                        }
                    }
                    else if (rs.resultCode === 126006) {
                        er = {
                            code: 126006,
                            errMsg: '该主播涉嫌违规，暂时无法关注'
                        };
                    }
                    else {
                        er = {
                            code: rs.resultCode,
                            errMsg: rs.errMsg
                        };
                    }
                    return [3, 6];
                case 5:
                    err_9 = _a.sent();
                    er = parseErr(err_9);
                    return [3, 6];
                case 6: return [4, onSubscription()];
                case 7:
                    _a.sent();
                    return [4, onAttention()];
                case 8:
                    _a.sent();
                    if (r) {
                        callback(r);
                    }
                    else {
                        callback(false, er.errMsg);
                    }
                    stat_1.metrics(stat_1.EMetricsType.FOLLOW, {
                        cost: +new Date() - timeStart,
                        code: er ? er.code : 0
                    });
                    return [2, [er, r]];
            }
        });
    });
}
exports.attention = attention;
function onAttention(fn) {
    return __awaiter(this, void 0, void 0, function () {
        var cacheIds_1, _a, er, ids_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!fn) return [3, 1];
                    cacheOnAttendtionFns.push(fn);
                    return [3, 4];
                case 1:
                    if (!cacheOnAttendtionFns.length) return [3, 4];
                    cacheIds_1 = cacheSubscription[getUidSync()];
                    if (!cacheIds_1) return [3, 2];
                    cacheOnAttendtionFns.forEach(function (fn) {
                        fn(cacheIds_1);
                    });
                    return [3, 4];
                case 2: return [4, fetchAttentionList()];
                case 3:
                    _a = _b.sent(), er = _a[0], ids_2 = _a[1];
                    if (!er) {
                        cacheOnAttendtionFns.forEach(function (fn) {
                            fn(ids_2);
                        });
                    }
                    _b.label = 4;
                case 4: return [2];
            }
        });
    });
}
exports.onAttention = onAttention;
function isCherish(uid, callback) {
    return __awaiter(this, void 0, void 0, function () {
        var r, er, rs, err_10;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isLoginSync()) return [3, 2];
                    return [4, showYYLoginBox()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4, ajaxGet(INTERFACE.CHERISH_LIST.replace('{$anchorUid}', "" + uid), { timeout: TIMEOUT_LIMIT })];
                case 3:
                    rs = _a.sent();
                    if (rs.resultCode === 0) {
                        r = rs.data;
                    }
                    else {
                        er = {
                            code: rs.result,
                            errMsg: rs.errMsg
                        };
                    }
                    return [3, 5];
                case 4:
                    err_10 = _a.sent();
                    er = parseErr(err_10);
                    return [3, 5];
                case 5:
                    if (!er) {
                        callback(r);
                    }
                    else {
                        callback(false, er.errMsg);
                    }
                    return [2, [er, r]];
            }
        });
    });
}
exports.isCherish = isCherish;
function fetchMyMedia() {
    return __awaiter(this, void 0, void 0, function () {
        var url, er, rs, r, err_11;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = INTERFACE.MY_MIDIA.replace('{$time}', "" + +new Date());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, then_ajax_1.thenJsonp(url, undefined, { timeout: TIMEOUT_LIMIT })];
                case 2:
                    rs = _a.sent();
                    if (rs.code === 0) {
                        r = rs.list;
                    }
                    else {
                        er = {
                            code: rs.code,
                            errMsg: rs.errMsg
                        };
                    }
                    return [3, 4];
                case 3:
                    err_11 = _a.sent();
                    er = parseErr(err_11);
                    return [3, 4];
                case 4: return [2, [er, r]];
            }
        });
    });
}
exports.fetchMyMedia = fetchMyMedia;
function getSponsorInfo(op, done) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, er, r;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, fetchSponsorInfo(op)];
                case 1:
                    _a = _b.sent(), er = _a[0], r = _a[1];
                    done(er, r);
                    return [2];
            }
        });
    });
}
exports.getSponsorInfo = getSponsorInfo;
function fetchSponsorInfo(op) {
    return __awaiter(this, void 0, void 0, function () {
        var options, iUrl, rs, er, r, err_12;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    options = Object.assign({
                        sid: 0,
                        ssid: 0,
                        pid: '',
                        uid: 0,
                        first: false
                    }, op);
                    iUrl = '';
                    if (options.pid) {
                        iUrl = INTERFACE.SPONSOR_INFO_XIANCHANG
                            .replace('{$uid}', "" + (options.uid || -1))
                            .replace('{$pid}', options.pid)
                            .replace('{$time}', "" + +new Date())
                            .replace(/\{\$first\}/g, options.first ? 'true' : 'false');
                    }
                    else {
                        iUrl = INTERFACE.SPONSOR_INFO
                            .replace('{$uid}', "" + options.uid)
                            .replace('{$sid}', "" + options.sid)
                            .replace('{$ssid}', "" + options.ssid)
                            .replace('{$time}', "" + +new Date())
                            .replace(/\{\$first\}/g, options.first ? 'true' : 'false');
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, then_ajax_1.thenJsonp(iUrl, undefined, { timeout: TIMEOUT_LIMIT })];
                case 2:
                    rs = _a.sent();
                    return [3, 4];
                case 3:
                    err_12 = _a.sent();
                    er = parseErr(err_12);
                    return [3, 4];
                case 4:
                    if (rs && rs.resultCode === 0) {
                        r = rs.data;
                    }
                    else {
                        if (rs) {
                            er = {
                                code: rs.resultCode,
                                errMsg: rs.errMsg
                            };
                        }
                        else {
                            er = {
                                code: 'ajax_error',
                                errMsg: ''
                            };
                        }
                    }
                    return [2, [er, r]];
            }
        });
    });
}
exports.fetchSponsorInfo = fetchSponsorInfo;
function isGuild() {
    return __awaiter(this, void 0, void 0, function () {
        var res, er_1, json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, axios_1["default"].get(INTERFACE.USER_TYPE, { withCredentials: true })];
                case 1:
                    res = _a.sent();
                    return [3, 3];
                case 2:
                    er_1 = _a.sent();
                    return [2, false];
                case 3:
                    json = res.data;
                    if (!json) {
                        return [2, false];
                    }
                    if (~[1, 2, 3].indexOf(json.data)) {
                        return [2, true];
                    }
                    else {
                        return [2, false];
                    }
                    return [2];
            }
        });
    });
}
exports.isGuild = isGuild;
exports.user = {
    fetchUserInfo: fetchUserInfo,
    getUserInfo: getUserInfo,
    getSponsorInfo: getSponsorInfo,
    fetchUserInfoByRevenue: fetchUserInfoByRevenue,
    getUserInfoByRevenue: getUserInfoByRevenue,
    fetchLiveInfo: fetchLiveInfo,
    getLiveInfo: getLiveInfo,
    fetchMyFollow: fetchMyFollow,
    getMyFocus: getMyFocus,
    showYYLoginBox: showYYLoginBox,
    showYYRegBox: showYYRegBox,
    hideYYLoginBox: hideYYLoginBox,
    hideYYRegBox: hideYYRegBox,
    fetchAttentionList: fetchAttentionList,
    queryAttentionList: queryAttentionList,
    onAttention: onAttention,
    attention: attention,
    fetchSubscriptionList: fetchSubscriptionList,
    querySubscriptionList: querySubscriptionList,
    onSubscription: onSubscription,
    subscription: subscription,
    isLoginSync: isLoginSync,
    getUidSync: getUidSync,
    getNickSync: getNickSync,
    getUserInfoSync: getUserInfoSync,
    logout: logout,
    getUdbMC: getUdbMC,
    getMacAddr: getMacAddr,
    getQrcodeSync: getQrcodeSync,
    isAttentionSync: isAttentionSync,
    isSubscriptionSync: isSubscriptionSync,
    isGuild: isGuild
};

}.call(window));